// extracted by mini-css-extract-plugin
module.exports = {"url-input":"SparqlFetch_url-input__1lnkc","query-input-here":"SparqlFetch_query-input-here__3Enuq","base-iri-input-here":"SparqlFetch_base-iri-input-here__2m44b"};